module.exports = __webpack_public_path__ + "static/img/ol.dbcb30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/ol.jpg
// module id = v4Tf
// module chunks = 7